"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = require("styled-components");
exports.SearchResultList = styled_components_1.default.div `
  flex: 1 0 40%;
  overflow: scroll;
  border-right: 1px solid rgb(26, 24, 68);
`;
//# sourceMappingURL=search-result-list.js.map